import { useState } from 'react';
import Finish  from "./finish";

interface AgendaStep5Questions {
  setStepValue: (value: string) => void;
  setCurrentStep: (value: string) => void;
  stepData: any;
}

export default function AgendaStep5Questions({ setStepValue, setCurrentStep, stepData }: AgendaStep5Questions) {
  const [finish, setFinish] = useState(false);
  const [canContinue, setCanContinue] = useState(false);

  const questionsAll = [
    {
      question_1: [
        {
          question: ' ¿Tiene antecedentes de reacciones adversas a la inyección de medios de contraste basado en gadolinio?',
          text_example: ''
        },
        {
          question: '¿Está embarazada o tiene probabilidades de embarazo?',
          text_example: ''
        },
        {
          question: '¿Está en tratamiento por asma actualmente? Medicamentos y/o inhaladores',
          text_example: ''
        },
        {
          question: '¿Es usted usuario de marcapasos?',
          text_example: ''
        },
        {
          question: '¿Es usted alérgico al látex?',
          text_example: ''
        },
        {
          question: '¿ Es Claustrofóbico?',
          text_example: ''
        },
        {
          question: ' ¿Es usted usuario de Implantes Metálicos?',
          text_example: ''
        }
      ]
    },
    {
      question_2: [
        {
          question: '¿Tiene antecedentes de reacciones adversas a la inyección de medios de contraste iodados?',
          text_example: 'Ejemplo: Rush cutáneo, dificultad para respirar, crisis asmática, shock anafiláctico.'
        },
        {
          question: '¿Ha acudido a una urgencia, y/o lo han hospitalizado por reacciones adversas al medio de contraste?',
          text_example: ''
        },
        {
          question: '¿Está en tratamiento por asma actualmente? Medicamentos y/o inhaladores',
          text_example: ''
        },
        {
          question: '¿Tiene diabetes?',
          text_example: ''
        },
        {
          question: '¿Tiene hipertensión arterial, insuficiencia renal o es monorreno?',
          text_example: ''
        },
        {
          question: '¿Es usted alérgico al látex?',
          text_example: ''
        }
      ]
    }
  ];

  let stepFourthExamenes = JSON.parse(stepData.StepFourthExamenes);
  console.log('stepFourthExamenes stepData', stepData);
  let questions: { question: string; text_example: string; }[] = [];
  if(stepFourthExamenes.sped_id === 'resonancia_magnetica') {
    questions = questionsAll[0].question_1 || [];
    console.log('stepFourthExamenes.sped_id', stepFourthExamenes.sped_id)
  }
  if(stepFourthExamenes.sped_id !== 'resonancia_magnetica') {
    questions = questionsAll[1].question_2 || [];
    console.log('stepFourthExamenes.sped_id', stepFourthExamenes.sped_id)
  }

  const [questionsList, setQuestionsList] = useState(questions.map(() => ({ yes: '0', no: '0', question: '' })));

  const currentStep = (step:string) => {
    if (step === 'yes') {
      const stepFourthExamenes = JSON.parse(stepData.StepFourthExamenes);
      stepFourthExamenes.questions = questionsList;
      stepData.StepFourthExamenes = JSON.stringify(stepFourthExamenes);
      setCurrentStep('solicitar-contacto');
    }
    if (step === 'no') {
      let idOffice = '';
      if (stepData.StepTwoExamenes === 'maipu_examenes') {
        idOffice = '239';
      } else if (stepData.StepTwoExamenes === 'providencia_examenes') {
        idOffice = '2';
      }
      setFinish(true);
      (window as any).show_agenda_eniax({
        "sped_id": stepFourthExamenes.sped_id,
        "doc_id": stepFourthExamenes.examen,
        "office_id": idOffice
      });
    }
  };

  const toggleQuestion = (index:number, answer:string) => {
    const newQuestionsList = [...questionsList];

    newQuestionsList[index].question = questions[index].question;
    if (questionsList[index].yes === '1' && answer === 'yes') {
      newQuestionsList[index].yes = '0';
      setQuestionsList(newQuestionsList);
      isEveryRowValid(newQuestionsList) ? setCanContinue(true) : setCanContinue(false);
      return true;
    } else if (questionsList[index].yes === '0' && answer === 'yes') {
      newQuestionsList[index].yes = '1';
      newQuestionsList[index].no = '0';
      setQuestionsList(newQuestionsList);
      isEveryRowValid(newQuestionsList) ? setCanContinue(true) : setCanContinue(false);
      return true;
    }

    if (questionsList[index].no === '1' && answer === 'no') {
      newQuestionsList[index].no = '0';
      setQuestionsList(newQuestionsList);
      isEveryRowValid(newQuestionsList) ? setCanContinue(true) : setCanContinue(false);
      return true;
    } else if (questionsList[index].no === '0' && answer === 'no') {
      newQuestionsList[index].no = '1';
      newQuestionsList[index].yes = '0';
      setQuestionsList(newQuestionsList);
      isEveryRowValid(newQuestionsList) ? setCanContinue(true) : setCanContinue(false);
      return true;
    }
  };

  interface Question {
    yes: string;
    no: string;
    question: string;
  }

  const isEveryRowValid = (questionsList: Question[]) => {
    return questionsList.every((row: Question) => row.yes === '1' || row.no === '1');
  };

  const isAtLeastOneYesTrue = (questionsList: Question[]) => {
    return questionsList.some((row: Question) => row.yes === '1');
  };

  return (
    <>
      {finish && (<Finish />)}
      {!finish && (
        <div>
          <div className="agenda-container">
            <div className='mt-30'>
              <h2 className='pretitle'>Reserva de horas</h2>
              <h3 className='content-title mb-20'>Cuestionario de seguridad imagenología</h3>
              <h4 className='fw-700 fz-13 text-center text-gray'>Para continuar necesita contestar las
                siguientes preguntas:</h4>
              {(stepFourthExamenes.sped_id !== 'resonancia_magnetica') && (
                  <div className='mt-30 text-center text-gray fz-13 fw-700 maxw-450 mx-auto'>
                    <h4 className='mt-20'>Si tu examen dice con contraste y tienes 70 años o más debes traer un examen
                      de creatinina de no más de 30 días, no tienes y necesitas orden para realizar este examen puedes
                      pedir una por correo a:
                      <a href='mailto:recepcion.radiologia@indisa.cl'> recepcion.radiologia@indisa.cl</a>
                    </h4>
                  </div>)}
            </div>

            <div className="mt-30 maxw-450 mx-auto">
              {questions.map((question, index) => (
                  <div key={index}>
                    <div className="agenda-question-container">
                      <p className="agenda-question fz-13 fw-400 text-gray mb-5 lh-20 d-flex">
                      <span className="agenda-question fz-13 fw-700 text-gray mb-5 lh-16 d-block mr-5">
                        {index + 1}.
                      </span>
                        <span className="d-block"> {question.question}</span>
                      </p>
                      <p className="agenda-question-text fz-12 text-gray_2 lh-16">
                        {question.text_example}
                      </p>
                    </div>
                    <div className="d-flex mb-20">
                      <button
                          className={`bd-1 bd-radius-8 background-white w-full p-11 ${questionsList[index].yes === '1' ? 'active' : ''}`}
                          onClick={() => toggleQuestion(index, 'yes')}
                      >
                        Si
                      </button>
                      <button
                          className={`bd-1 bd-radius-8 background-white w-full p-11 ml-5 ${questionsList[index].no === '1' ? 'active' : ''}`}
                          onClick={() => toggleQuestion(index, 'no')}
                      >
                        No
                      </button>
                    </div>
                  </div>
              ))}
            </div>

            <div className="button-container mt-30 maxw-450 mx-auto">
              <a href="#" type="button"
                 className={`button-orange next-step-1 ${canContinue ? '' : 'disabled'}`}
                 onClick={() => currentStep(isAtLeastOneYesTrue(questionsList) ? 'yes' : 'no')}
              >
                CONTINUAR
              </a>
              <a href="#" onClick={() => setCurrentStep('imagenologia')} className="button-border mt-15">
                Atrás
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
